import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { Package, Clock, CheckCircle2, Train } from 'lucide-react';

import { API } from '../config';

const MyOrders = () => {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const t = localStorage.getItem('tp_token');
        const r = await axios.get(`${API}/orders/me`, { headers: { Authorization: `Bearer ${t}` } });
        setOrders(r.data);
      } catch (e) { /* ignore */ }
      finally { setLoading(false); }
    };
    if (user) load();
    else setLoading(false);
  }, [user]);

  if (!user) return (
    <div className="max-w-md mx-auto p-10 text-center">
      <h2 className="text-xl font-bold text-[#0B2E5C]">Please login to view orders</h2>
      <Link to="/login" className="inline-block mt-4 bg-tp-orange text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#E07A0F]">Login now</Link>
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto px-4 py-4 md:py-5">
      <h1 className="text-2xl font-bold text-[#0B2E5C] mb-4">My Orders</h1>
      {loading ? <div className="text-gray-500">Loading...</div> : (
        orders.length === 0 ? (
          <div className="text-center py-20 bg-white rounded-xl border border-gray-100">
            <Package className="mx-auto text-gray-300" size={48} />
            <p className="mt-3 text-gray-500">No orders yet</p>
            <Link to="/food-on-train" className="inline-block mt-4 bg-tp-orange text-white px-6 py-2 rounded-lg font-semibold">Order Food</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {orders.map(o => (
              <div key={o.id} className="bg-white rounded-xl p-5 border border-gray-100 card-shadow">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="text-xs text-gray-500">Order #{o.id.slice(0,8).toUpperCase()}</div>
                    <div className="font-semibold text-[#0B2E5C] mt-0.5">{o.restaurant_name}</div>
                    <div className="text-xs text-gray-500 flex items-center gap-1 mt-1"><Train size={12} /> PNR {o.pnr} • {o.station_code}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-[#0B2E5C]">₹{o.total}</div>
                    <div className={`text-xs mt-1 inline-flex items-center gap-1 px-2 py-0.5 rounded ${o.status==='delivered' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                      {o.status==='delivered' ? <CheckCircle2 size={12}/> : <Clock size={12}/>} {o.status}
                    </div>
                  </div>
                </div>
                <div className="mt-3 text-xs text-gray-500 border-t pt-2">
                  {o.items?.map(i => i.name + ' x' + i.qty).join(' • ')}
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default MyOrders;
